import { ThemeOptions } from 'interfaces/main';
import { WNSTN_THEME_DARK, WNSTN_THEME_LIGHT } from '@leverate/common-client';

export const mapThemeToWnstn = (theme: string): string => {
    return theme === ThemeOptions.DARK ? WNSTN_THEME_DARK : WNSTN_THEME_LIGHT;
};
